import axios from 'axios';
import axiosClient from './axiosClient';

// Origin backend chứa file tĩnh + ảnh utility (đồng bộ với SERVER_ORIGIN của app).
export const UTILITY_ORIGIN =
    process.env.REACT_APP_API_PUBLIC_URL ||
    process.env.REACT_APP_API_URL?.replace('/api/v1', '') ||
    '';

// Nguồn nhanh nhất: file tĩnh trên VPS (đặt trong /img/, không đập DB).
const STATIC_URL = `${UTILITY_ORIGIN}/img/utility-blocks.json`;
const VALID_MODES = ['appview', 'webview', 'external', 'screen'];

// Bỏ block hỏng: mode 'screen' cần screenName; còn lại cần link.
function sanitize(arr) {
    return (Array.isArray(arr) ? arr : []).filter((b) => {
        if (!b || !VALID_MODES.includes(b.openMode)) return false;
        if (b.openMode === 'screen')
            return typeof b.screenName === 'string' && b.screenName.length > 0;
        return typeof b.link === 'string' && b.link.length > 0;
    });
}

function normalize(raw) {
    const list = Array.isArray(raw?.blocks)
        ? raw.blocks
        : Array.isArray(raw?.data)
        ? raw.data
        : [];
    return { version: Number(raw?.version) || 0, blocks: sanitize(list) };
}

// Lấy danh sách tiện ích: file tĩnh (nhanh, không auth) → fallback /config (đọc DB).
async function fetchUtilityConfig() {
    try {
        // Cache-bust: nginx cache /img/ 7 ngày (max-age=604800) → ?t=Date.now() là đủ
        // để luôn lấy bản mới khi admin sửa. Chỉ chạy mỗi lần load Home nên vẫn nhẹ.
        //
        // ⚠️ KHÔNG thêm header 'Cache-Control' (hay bất kỳ header non-simple nào) vào
        // request này: nó biến GET thành preflighted request, browser gửi OPTIONS tới
        // /img/utility-blocks.json — nginx serve file tĩnh nên trả 405 → trình duyệt
        // báo "blocked by CORS policy: preflight ... does not have HTTP ok status",
        // request thật bị huỷ và phải đi đường fallback /api/v1 (đập DB, chậm hơn).
        // GET không header = simple request ⇒ không preflight; nginx đã set
        // access-control-allow-origin:* cho /img nên qua CORS bình thường.
        const res = await axios.get(STATIC_URL, {
            timeout: 10000,
            params: { t: Date.now() },
        });
        return normalize(res.data);
    } catch {
        // CORS / 404 file tĩnh → đọc DB qua API (đã có CORS sẵn cho /api/v1).
        const res = await axiosClient.get('utility-block/config');
        return normalize(res.data);
    }
}

// Đếm lượt bấm 1 block (fire-and-forget, không chặn việc mở link).
function trackUtilityClick(id) {
    axiosClient.post(`utility-block/${id}/click`).catch(() => {});
}

const utilityBlockApi = { fetchUtilityConfig, trackUtilityClick };

export default utilityBlockApi;
